<template>
  <BomCar :editable="false"></BomCar>
</template>

<script>

import ConstDef from '../../share/ConstDef'
import BomCar from './BomCar.vue'

export default {
  name: 'login',
  data: function () {
    return {
    }
  },
  components: {
    BomCar
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>
